import { useStore } from '@nanostores/react';
import { PricingCardBase } from './PricingCardBase';
import { Button } from '~/components/ui/Button';
import { FREE_PLAN_PERKS } from '~/lib/stores/pricing/config';
import { freePlanStore, type FreePricingCardAction } from '~/lib/stores/pricing/freePlan';
import { pricingStore } from '~/lib/stores/pricing/pricing';
import { userStore } from '~/lib/stores/user';

export const FreePlanCard = () => {
  const actions = useStore(freePlanStore.actions);

  return (
    <PricingCardBase
      title="Free"
      price={0}
      billedLabel="Never billed!"
      perks={{
        label: 'You get:',
        items: FREE_PLAN_PERKS,
      }}
      messages={[]}
    >
      {actions.map((action) => (
        <FreePlanCardAction key={action.type} action={action} />
      ))}
    </PricingCardBase>
  );
};

const FreePlanCardAction = ({ action }: { action: FreePricingCardAction }) => {
  const loading = useStore(freePlanStore.isLoading);
  const loggedIn = useStore(userStore.loggedIn);
  const pricingBeingRequested = useStore(pricingStore.pricingBeingRequested);

  const disabled = pricingBeingRequested?.type === 'pro' || pricingBeingRequested?.type === 'teams';

  if (!loggedIn) {
    return (
      <Button size="lg" onClick={() => pricingStore.authDialogOpen.set(true)}>
        Get started
      </Button>
    );
  }

  if (action.type === 'active') {
    return (
      <span className="flex items-center justify-center h-10 text-sm text-bolt-ds-textPrimary bg-bolt-ds-inverseSurface/10 rounded-lg">
        Your current plan
      </span>
    );
  }

  if (action.type === 'downgrade') {
    return (
      <Button
        variant="secondary"
        size="lg"
        onClick={() => action.onDowngrade()}
        loading={loading}
        disabled={disabled || !!action.disabilityReason}
        title={action.disabilityReason}
      >
        Downgrade to Free
      </Button>
    );
  }

  if (action.type === 'disabled') {
    return (
      <Button variant="secondary" size="lg" disabled>
        {action.reason}
      </Button>
    );
  }

  if (action.type === 'renew-subscription') {
    return (
      <>
        <Button variant="secondary" size="lg" disabled>
          Downgrade scheduled
        </Button>

        <Button
          onClick={action.onRenew}
          variant="link-gray"
          className="text-bolt-ds-textPrimary"
          loading={loading}
          disabled={disabled}
        >
          Cancel downgrade
        </Button>
      </>
    );
  }

  return null;
};
